import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
  },
  header: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: theme.spacing(4),
  },
}))

export default useStyles
